import { useState } from "react";

import RefundToolData from "./RefundToolData";

const useRefundToolData = () => {
  const [refundToolState, setRefundToolState] = useState(RefundToolData.INITIAL_REFUND_TOOL_STATE);

  const postPaymentRefund = (receiptNumber, itemsToRefund) => {
    return RefundToolData.postPaymentRefundData(receiptNumber, itemsToRefund, refundToolState, setRefundToolState);
  };

  const getPaymentRefund = (receiptNumber) => {
    return RefundToolData.getPaymentRefundData(receiptNumber, refundToolState, setRefundToolState);
  };

  const resetRefundToolState = () => {
    setRefundToolState(RefundToolData.INITIAL_REFUND_TOOL_STATE);
  };

  return {
    refundToolState,
    postPaymentRefund,
    getPaymentRefund,
    resetRefundToolState
  };
};

export default useRefundToolData;